import { isNil } from 'lodash-es';

export default function parseEscapeData(str) {
  if (isNil(str)) throw new Error('Input cannot be null or undefined');

  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');

  return JSON.parse(doc.body.textContent);
}
